<template>

  <div id="header">

    <div class="header">
  
      <ul class="headMenu">
        <li class="businessLogo"><img src="../assets/haokuLogo.png" class="businessLogo"></li>
        <router-link  class="menuItem" to="/">首页</router-link>
        <router-link  class="menuItem" to="/product">产品</router-link>
        <router-link  class="menuItem" to="/example">案例</router-link>
        <router-link  class="menuItem" to="/methods">商务合作</router-link>
        <router-link  class="menuItem" to="/about">关于我们</router-link>
        <router-link  class="menuItem" to="/join">加入我们</router-link>
        <li class="qqLogo2"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=120605580&site=qq&menu=yes"><img src="../assets/qq.png" class="qqLogo"></a></li>
        <li class="qqLogo2"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=451429350&site=qq&menu=yes"><img src="../assets/qq.png" class="qqLogo"></a></li>
      </ul>
   
    </div>

  </div>

</template>

<script>
export default {
  name: 'header',

  data (){
      return {
      }
  },

}
</script>

<style scoped>
.headMenu a {
  text-decoration: none;
}
.router-link-exact-active {
  color: #0099cc;
  border-bottom: 3px solid #0099cc;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
}

/* header */

.header {
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 2px 0 0 rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
}

.headMenu {
    display: flex;
}

.headMenu li {
    padding: 1rem 0;
}

.hello {
    width: 100%;
}

.businessLogo {
    margin-right: 3.5rem;
}

.bussinessLogo {
    width: 161px;
    height: auto;
    position: relative;
}

.qqLogo2 {
    margin-left: 2.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.menuItem {
    position: relative;
    width: 6.3rem;
    cursor: pointer;
    letter-spacing: 0.04rem;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
}
.menuItem:hover {
  color: #0099cc;
  border-bottom: 3px solid #0099cc;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
}
.onMouseActive {
    color: #42a4fc
}
</style>



// WEBPACK FOOTER //
// Header.vue?58cc14bd